export function appScreen(screen) {
    return {
        type: 'APP_SCREEN',
        appScreen: screen
    }
}



// WEBPACK FOOTER //
// ./src/lib/redux/actions/app.js